import script from "./RcDropdownItemRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdownItemRadio.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdownItemRadio.vue?vue&type=style&index=0&id=749cec82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749cec82"]])

export default __exports__